export const LANG_STORAGE_KEY = 'lang';
